import { CheckNotes, InspectionCase } from '../../inspection-cases';

export class FloodingCoolingExtinguishingSystemsDto extends InspectionCase {
  manufacturerNameAndModel?: InspectionCase;
  systemOperationDescription?: InspectionCase;
}

export class FloodingCoolingExtinguishingSystems extends FloodingCoolingExtinguishingSystemsDto {
  constructor(
    data: FloodingCoolingExtinguishingSystemsDto = {
      title: 'מערכות הצפה/ קירור/ כיבוי'
    }
  ) {
    super(data);
    this.manufacturerNameAndModel = new InspectionCase({
      ...data.manufacturerNameAndModel,
      title: 'שם היצרן ודגם תחנת ההפעלה'
    });
    this.systemOperationDescription = new InspectionCase({
      ...data.systemOperationDescription,
      title: `תאר את אופן הפעלת המערכת: גלאים / מתזי ניווט / וכד'`
    });
  }

  setInspectionStatus(): void {
    this.isPassed =
      !this.isApplicable ||
      ((!this.manufacturerNameAndModel.isApplicable ||
        this.manufacturerNameAndModel.isPassed) &&
        (!this.systemOperationDescription.isApplicable ||
          this.systemOperationDescription.isPassed));
  }

  getNotes?(): CheckNotes[] {
    if (!this.isApplicable) {
      return [];
    }
    return [
      ...this.manufacturerNameAndModel.getNotes(),
      ...this.systemOperationDescription.getNotes()
    ];
  }
}
